require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-05-31-leaving-msp.json") })
        }
      }, "path---articles-2009-05-31-leaving-msp");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-05-31-leaving-msp!./.cache/json/articles-2009-05-31-leaving-msp.json
// module id = 566
// module chunks = 231608221292675